/**
 * File: apps/qbench-cp/reactapp/src/Dashboard/reducers/reducer.js
 *
 * Purpose: General-purpose reducer for the Dashboard's non-filter state fields.
 *
 * Scope: Dashboard state management within the customer portal.
 *
 * Tags: customer-portal
 *
 * Overview: Handles a generic SET_FIELD action for assigning an arbitrary named field on state,
 *     an ORDERS_LOADED action that stores fetched orders and marks the orders widget as loaded,
 *     and a LOG action that marks state as logged. Any other action type is a no-op that returns
 *     state unchanged.
 *
 * Exports: reducer (default export).
 */

const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'SET_FIELD':
      return {
        ...state,
        [payload.name]: payload.value,
      };
    case 'ORDERS_LOADED':
      return {
        ...state,
        orders: payload,
        ordersWidgetLoaded: true,
      };
    case 'LOG':
      return {
        ...state,
        logged: true,
      };
    default:
      return state;
  }
};

export default reducer;
